// src/i18n/es/durations.ts
// «Tiempos» (mockup 07) — route /durations, Dirección.
export const durations = {
  name: 'Tiempos |||| Tiempos',
  subtitle: 'Cuánto tardan los huéspedes en cada canal',

  bucketsSwitch: {
    standard: 'Estándar',
    fastKiosk: 'Kiosco rápido',
  },

  table: {
    title: 'Duración por canal',
    description:
      'Llegadas del periodo. Online: duración del pre-check-in hecho online, de su inicio a su finalización. Kiosco, Móvil y Air Lobby: del inicio del check-in a su finalización en ese canal, sin la entrega de la llave. Con menos de 20 casos no se muestran mediana, P75 ni porcentajes.',
    columns: {
      channel: 'Canal',
      count: 'Casos',
      medianSeconds: 'Mediana',
      p75Seconds: 'P75',
      under2MinPct: '< 2 min',
      under5MinPct: '< 5 min',
    },
  },

  ranges: {
    title: 'Por franjas de duración',
    description: 'Número de casos de cada canal en cada franja. Las franjas siguen su preferencia «Estándar» o «Kiosco rápido».',
    labels: {
      '<1m': '< 1 min',
      '1-2m': '1-2 min',
      '2-5m': '2-5 min',
      '5-10m': '5-10 min',
      '>10m': '> 10 min',
      '<30s': '< 30 s',
      '30-60s': '30-60 s',
      '>5m': '> 5 min',
    },
  },

  sections: {
    title: 'Duración por sección',
    columns: {
      section: 'Sección',
      count: 'Casos',
      medianSeconds: 'Mediana',
      p75Seconds: 'P75',
    },
  },

  byHour: {
    title: 'Por hora del día',
    description: 'Recorridos de todos los canales (dispensador incluido) por la hora local del hotel en que empezaron.',
    series: { count: 'Este periodo', previous: 'Periodo anterior' },
  },

  byWeekday: {
    title: 'Por día de la semana',
    description: 'Recorridos de todos los canales (dispensador incluido) por el día local del hotel en que empezaron.',
    series: { count: 'Este periodo', previous: 'Periodo anterior' },
    days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
  },

  leadTime: {
    title: 'Antelación: del inicio del pre-check-in a la llegada',
    description:
      'Días entre el día en que el huésped empezó el pre-check-in y su fecha de llegada, para las llegadas del periodo con pre-check-in terminado.',
    medianDays: 'Mediana: %{days} día |||| Mediana: %{days} días',
    excludedNegative:
      '%{count} llegada con el pre-check-in empezado después de la fecha de llegada no se incluye |||| %{count} llegadas con el pre-check-in empezado después de la fecha de llegada no se incluyen',
    buckets: {
      sameDay: 'El mismo día',
      '1-2d': '1-2 días',
      '3-7d': '3-7 días',
      '>7d': 'Más de 7 días',
    },
  },

  help: {
    title: 'Tiempos',
    description: 'Cuánto tardan los huéspedes en completar el pre-check-in y el check-in en cada canal, y con cuánta antelación llegan.',
    features: {
      buckets:
        'La tabla de franjas usa los umbrales «Estándar» o «Kiosco rápido» según su preferencia; se guarda en su cuenta y no afecta a otros usuarios.',
      leadTime: 'La antelación mide los días entre el inicio del pre-check-in y la fecha de llegada; no es lo que dura el pre-check-in.',
      sample: 'Medianas, P75 y porcentajes necesitan al menos 20 casos; por debajo verá «Muestra insuficiente» con el número de casos.',
    },
    tips: {
      medians: 'Se muestran medianas, no medias: un solo caso extremo no distorsiona el dato.',
    },
  },
};

export default durations;
